import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectIsWidgetVisible } from '../../../selectors/layout';
import { WidgetContainer } from '../Widget';

export const WidgetWrapperContainer = () => {
  const isVisible = useSelector(selectIsWidgetVisible);

  if (!isVisible) {
    return null;
  }

  return <WidgetContainer />;
};
